export enum Origin {
    CHAPA = 'buddy',
    SCHUDELING = 'scheduler',
    FINDER = 'finder'
}
